import { FC } from 'react';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';
import { WhatsappTemplateCard } from '../WhatsappTemplateCard';
import { WhatsappTemplateTable } from '../WhatsappTemplateTable';
import { VIEW_MODES, ViewMode } from '@/components/ViewToggle/ViewToggle';

type WhatsappTemplateListContentProps = {
  viewMode: ViewMode;
  items: WhatsappTemplate[];
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: WhatsappTemplate) => void;
};

export const WhatsappTemplateListContent: FC<WhatsappTemplateListContentProps> = ({ viewMode, items, onEdit, onRequestDelete }) => {
  if (viewMode === VIEW_MODES.TABLE) {
    return (
      <div className='overflow-x-auto rounded-2xl border border-secondary-border bg-white'>
        <WhatsappTemplateTable items={items} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      </div>
    );
  }

  return (
    <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-4'>
      {items.map((item) => (
        <WhatsappTemplateCard key={item.id} template={item} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      ))}
    </div>
  );
};
